import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { blockUi, addHeader } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Observable } from 'rxjs';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { NovasLiberacoesParaOperacao, OperacaoCreditoLivre } from 'src/app/model/operacao-credito-livre.model';

@Injectable({
  providedIn: 'root'
})
export class LiberacaoCreditoLivreService extends FgiBackEndService<NovasLiberacoesParaOperacao> {

  // @Override
  getNewEntity() {
    return new NovasLiberacoesParaOperacao();
  }

  // @Override
  protected getResourceURL(): string {
    return 'front/credito-livre/operacoes/liberacoes';
  }

  enviarLiberacoes(novasLiberacoes: NovasLiberacoesParaOperacao, apenasValidar: boolean): Observable<Array<OperacaoCreditoLivre>> {
    console.debug('enviando novas liberacoes ' + JSON.stringify([novasLiberacoes]));
    console.debug('apenas validar:' + apenasValidar);

    const options: any = blockUi();
    options.params.apenasValidacao = apenasValidar;

    return this.http.post(`${this.BASE_URL}/lote`, {liberacoesParaOperacoes: [novasLiberacoes]}, options).pipe(
           catchError((e) => this.handleError(e))) as Observable<Array<OperacaoCreditoLivre>>;
  }

}
